module.exports = {
    title: "Author",
    crud: {
        create: "Create Author",
        edit: "Edit Author",
    },
    table: {
        name: "Name",
        about: "About",
        mobile: "Mobile",
        address: "Address",
    },
    form: {
        name: "Name",
        about: "About",
        mobile: "Mobile",
        address: "Address",
    },
    validation: {
        required: {
            name: 'Name is required',
            mobile: 'Mobile is required',
        },
        minLength: {
            name: 'Name must have at least',
        },
        common: {
            letter: 'letters.',
        }
    },
}
